import { Injectable } from '@angular/core';
import { Params } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class NavTrackingService {

  previousNavItem: NavItem;
  currentNavItem: NavItem;

  constructor() { }

  setNavigationState(nextNavItem: NavItem) {
      if (this.currentNavItem)
          this.previousNavItem = this.currentNavItem;
      this.currentNavItem = nextNavItem;
  }
}

export class NavItem {

  order: number;
  path: string;
  params: Params;

  constructor (order: number, path: string, params?: Params) {
      this.order = order;
      this.path = path;
      this.params = params;
  }
}